import React from 'react';

import type { Size } from '@swf/core/models/modal';

export interface ModalContextValue {
  setStyle(state: {
    size?: Size;
    className?: string;
    overlayClassName?: string;
    hidden?: boolean;
    closeOnOverlayClick?: boolean;
    closeOnEsc?: boolean;
  }): void;
}

export const ModalContext = React.createContext<ModalContextValue>({
  setStyle: () => undefined
});
